<div class="table-header-row" *ngIf="commands">
  {{ title | uppercase }}
  <span class="toolbar">
    <miq-commands
      [resources]="childSelected"
      [commands]="commands"
      [errorCallback]="notify"
      (namedEvent)="handleInternalEvent($event, selectedItems)"
    ></miq-commands>
  </span>
</div>
<div class="childtable-component">
  <p-table
    [columns]="columns"
    [value]="elements"
    [ngClass]="{ 'complex-table-child-select-column-additonalWidth': selectable && showGoToRecordColumn }"
    [selection]="childSelected"
    (selectionChange)="selectedItemsChange.emit($event)"
    (onRowReorder)="rowReorderEvent.emit($event)"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <!-- Select All or Place holder for the link used to redirect the user to the record in a different tab -->
        <th scope="col" *ngIf="selectable || showGoToRecordColumn">
          <!-- Checkbox to select all rows -->
          <ng-conatiner *ngIf="selectable"
            ><miq-tableHeaderCheckbox [disabled]="disableSelection"></miq-tableHeaderCheckbox
          ></ng-conatiner>
        </th>
        <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
      <tr
        miq-complex-table-row
        [row]="rowData"
        [pReorderableRow]="rowIndex"
        [columns]="columns"
        [disableSelection]="disableSelection"
        [expandable]="false"
        [selectable]="selectable"
        [ngClass]="{ clickableRow: clickableRow, nonClickableRow: !clickableRow }"
        [showGoToRecordColumn]="showGoToRecordColumn"
        [rowLinkGenerator]="rowLinkGenerator"
        [sortable]="sortable"
        [sortMode]="sortMode"
        [sortMessage]="sortMessage"
        (click)="onRowClick(rowData)"
        (rowChange)="handleChange($event, rowData, rowIndex)"
        (clearSelection)="clearSelectionAndCheckSelectionBlock($event)"
      ></tr>
    </ng-template>
  </p-table>
</div>
